import Vue from "vue";

export class Fiberhome {
    /**
     *
     * @returns {Promise}
     */
    static offline() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fiberhome/offline")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise<any>}
     */
    static info(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fiberhome/info/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise<any>}
     */
    static infoFtth(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fiberhome/info/" + id + "/ftth")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @returns {Promise<any>}
     */
    static unregistered() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fiberhome/unregistered")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    static register(json) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("fiberhome/register", json)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    static unregister(_id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("fiberhome/unregister", { _id })
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    static unregisterFtth(_id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("fiberhome/unregister/ftth", { _id })
                .then(res => resolve(res.data), err => reject(err));
        });
    }
}
